module.exports = __webpack_public_path__ + "static/media/layout.e8a111a9.svg";